import { apiGet, apiRequest, apiPost, mockSuccess } from "@redriver/cinnamon";
import FileSaver from "file-saver";

const NAMESPACE = "SETTINGS_UPLOAD";

const ActionTypes = {
  GetDocumentAuditTrail: `${NAMESPACE}/GET_DOCUMENT_AUDIT_TRAIL`,
  GetDownloadAuditTrail: `${NAMESPACE}/GET_DOWNLOAD_AUDIT_TRAIL`,
};

export const getDocumentAuditTrail = ({ filters = {}, pagination }) => {
  const { docusignDateRange, ...otherFilters } = filters;

  const requestBody = {
    ...pagination,
    filters: {
      ...otherFilters,
      ...(docusignDateRange && {
        docusignDateRangeStart: docusignDateRange.start,
        docusignDateRangeEnd: docusignDateRange.end,
      }),
    },
  };

  return apiPost(
    ActionTypes.GetDocumentAuditTrail,
    "document-audit-trail",
    requestBody,
  );
};

export const exportDocumentAuditTrails = ({
  filters = {},
  pageSize,
  pageNumber,
}) => {
  const { docusignDateRange, ...otherFilters } = filters;

  return apiPost(
    ActionTypes.GetDownloadAuditTrail,
    "document-audit-trail/export",
    {
      pageSize,
      pageNumber,
      filters: {
        ...otherFilters,
        ...(docusignDateRange && {
          docusignDateRangeStart: docusignDateRange.start,
          docusignDateRangeEnd: docusignDateRange.end,
        }),
      },
    },
  );
};
